// import {join} from 'path'
// import {promisify} from "util";
// import {createWriteStream, existsSync} from "fs";

import ResearchApiConfig from '../ResearchApiConfig';

export interface Dimensions {
    width: number;
    height: number;
}

// const streamPipeline = promisify(require('stream').pipeline);

// const imageRoot = join(process.cwd(), 'public/images');

export const normalizedImageUrl = async (url: string) => {
    const localhostRegExp = /^http:\/\/\w+(\.\w+)*(:[0-9]+)?\/?(\/.*)*\/(.*)$/;
    const filename = url.match(localhostRegExp)?.reverse()[0];

    if (filename) {
        /*
        const filePath = join(imageRoot, filename);

        if (!existsSync(filePath)) {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`images.ts: unexpected response ${response.statusText}`);
            await streamPipeline(response.body, createWriteStream(filePath));
        }
        */
        return `${ResearchApiConfig.siteUrl}/images/${filename}`;
    }
    return url.startsWith('//') ? `https:${url}` : url;
};
